var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * component model
 */
import * as lodash from '../utils/lodash';
import merge from '../utils/merge';
import BaseModel from './baseModel';
/**
 * defautl
 */
var ComponentModel = /** @class */ (function (_super) {
    __extends(ComponentModel, _super);
    function ComponentModel(type, option, chart, extraInfo, parentModel) {
        var _this = _super.call(this) || this;
        _this.renderAfterSeires = false;
        _this.zindex = 0;
        _this.type = type;
        _this.chart = chart;
        _this.extraInfo = extraInfo;
        _this.parentModel = parentModel;
        _this._initOption(option, false);
        _this.state = _this.getInitialState();
        return _this;
    }
    // eslint-disable-next-line no-unused-vars
    ComponentModel.prototype.getDefaultOption = function (option, index) {
        return undefined;
    };
    ComponentModel.prototype.update = function (nextOption, mergedOld) {
        this._initOption(nextOption, mergedOld);
    };
    ComponentModel.prototype.getDependentSeries = function () {
        return this.chart.getSeriesByDependency(this.type);
    };
    ComponentModel.prototype.getSideAreaSize = function () {
        return {
            side: 'left',
            size: 0,
        };
    };
    ComponentModel.prototype._initOption = function (option, mergedOld) {
        var sourceOption = mergedOld ? this.option : this.getDefaultOption(option, this.extraInfo);
        this.option = merge(sourceOption, this.getThemeOption(option), option);
        var _a = this.constructor, type = _a.type, multiple = _a.multiple;
        if (!this.parentModel && this.option && type) {
            if (!multiple) {
                lodash.set(this.chart.getOption(), type, this.option);
            }
            else {
                lodash.set(this.chart.getOption(), [type, this.extraInfo.index], this.option);
            }
        }
    };
    ComponentModel.dependencies = [];
    ComponentModel.multiple = false;
    return ComponentModel;
}(BaseModel));
export default ComponentModel;
